const STORAGE_KEY = 'hbSectionCache.v1';
const MAX_ITEMS = 50;

// In-memory map for speed
let mem = new Map();

// Hydrate from sessionStorage on first import
(function hydrate() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    const arr = JSON.parse(raw);
    if (Array.isArray(arr)) {
      mem = new Map(arr.map(([k, v]) => [Number(k), v]));
    }
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('Failed to hydrate handbook cache', err);
    }
  }
})();

function persist() {
  try {
    const arr = Array.from(mem.entries());
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(-MAX_ITEMS)));
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('Failed to persist handbook cache', err);
    }
  }
}

export function putSection(section) {
  if (!section || !section.id) return;
  mem.set(Number(section.id), section);
  if (mem.size > MAX_ITEMS) {
    const firstKey = mem.keys().next().value;
    mem.delete(firstKey);
  }
  persist();
}

export function getSectionMaybeCached(id) {
  const key = Number(id);
  return mem.has(key) ? mem.get(key) : null;
}

export function clearHandbookCache() {
  mem.clear();
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('Failed to clear handbook cache', err);
    }
  }
}

export function handbookCacheSize() {
  return mem.size;
}